import { FormattedMessage } from 'react-intl';

import { CopyIcon } from '../../components/CopyIcon';
import { Chevron } from '../../components/layout/Chevron';
import { Link } from '../../components/Link';
import { RefreshButton } from '../../components/RefreshButton';
import { ReactComponent as IconChatDots } from '../../icons/icon-chats-dots.svg';
import type { Topic } from '../../types/api';
import { yakliMessages } from './yakliMessages';

type YakliHeaderProps = {
  slug: string;
  topic: Topic;
  messageId: string;
  forceRefetch: () => void;
};

export const YakliHeader = ({ slug, topic, messageId, forceRefetch }: YakliHeaderProps) => {
  return (
    <div className="flex flex-col items-center text-center mb-6">
      <h2 className="mb-2 text-lg justify-center text-primary font-normal md:font-semibold flex space-x-3 items-center">
        <IconChatDots className="hidden md:block" />
        <span>Fil de discussion</span>
        <RefreshButton
          className="self-center"
          iconContainerClassName="self-center"
          verticalAlign={null}
          refreshAction={forceRefetch}
        />
      </h2>
      <h3 className="font-normal text-base2">
        <FormattedMessage {...yakliMessages.subtitlePrefix} />{' '}
        <Link to={'topic'} params={{ slug }}>
          <a>
            <em>
              “<span className="font-bold underline">{topic.subject}</span>”
            </em>
          </a>
        </Link>
      </h3>
      <hr className="w-[110px] my-6 border-gray-280" />
      <div className="flex justify-center items-center gap-4 flex-wrap">
        <Link to={'topic'} params={{ slug, from: 'bubbleFlow' }}>
          <a className="underline">
            <FormattedMessage {...yakliMessages.allDiscussions} />
          </a>
        </Link>
        <Chevron />
        <div className="flex space-x-2 items-center">
          <span>
            <FormattedMessage {...yakliMessages.uniqueDiscussion} />
          </span>
          <div className="flex bg-gray-50 rounded-lg min-w-[140px] justify-center">
            <CopyIcon messageId={messageId} slug={slug} />
          </div>
        </div>
      </div>
    </div>
  );
};
